export const prepareEnquiry = subject => {
  window.dispatchEvent(new CustomEvent('lde:enquiry', { detail: { subject } }));
};

export const focusEnquiry = () => {
  window.requestAnimationFrame(() => {
    const form = document.querySelector('[data-testid="quick-inquiry-form"]');
    if (!form) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = form.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
    form.querySelector('input[name="name"]')?.focus({ preventScroll: true });
  });
};

export const openEnquiry = subject => {
  prepareEnquiry(subject);
  focusEnquiry();
};
